import { currentPage } from '../common/layout';

currentPage.pageInit = ($page, pageData, pageId) => {

    var $contentWrapper = $('.content-wrapper');

    $contentWrapper.on('click', '.personsWithDetailInfo .person', function(event) {
        var $this = $(this);
        var $href = $this.attr('href');
        console.log($href);

        if ($this.hasClass('noDetails')) return;

        // if ($(event.target).is('a')) {
        //     return;
        // }

        if ($href == '') {
            event.preventDefault();
            return;
        }
    });

}